/* Wolpic · captura de la vista previa del cliente · Ecom Project
   Dibuja en un canvas lo que el cliente armó (cuadros o álbum), lo sube al mismo Uploadcare donde Uploadly
   guarda sus fotos (guardado permanente) y devuelve el enlace para ponerlo en la línea del pedido.
   Si algo falla (sin señal, imagen bloqueada…) devuelve null: la compra nunca se bloquea. */
(function () {
  'use strict';
  if (window.WPCapture) return;

  var IMG_TIMEOUT = 12000, UPLOAD_TIMEOUT = 25000;

  function load(url, ms) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new Image(), done = false;
      function fin(ok) { if (done) return; done = true; clearTimeout(t); resolve(ok && img.naturalWidth ? img : null); }
      var t = setTimeout(function () { fin(false); }, ms || IMG_TIMEOUT);
      img.crossOrigin = 'anonymous';           // Uploadcare y el CDN de Shopify permiten CORS: el canvas no queda bloqueado
      img.decoding = 'async';
      img.onload = function () { fin(true); };
      img.onerror = function () { fin(false); };
      img.src = url;
    });
  }
  /* carga muchas imágenes con un máximo de descargas a la vez */
  function loadAll(urls, limit) {
    var out = new Array(urls.length), i = 0, active = 0;
    return new Promise(function (resolve) {
      if (!urls.length) return resolve(out);
      function next() {
        if (i >= urls.length && !active) return resolve(out);
        while (active < (limit || 6) && i < urls.length) {
          (function (k) {
            active++;
            load(urls[k]).then(function (im) { out[k] = im; active--; next(); });
          })(i++);
        }
      }
      next();
    });
  }

  /* igual que CSS object-fit: cover + object-position x% y% + transform: scale(z) con origen en x% y% */
  function cover(ctx, img, x, y, w, h, c) {
    c = c || { x: 50, y: 50, z: 1 };
    var px = (c.x == null ? 50 : c.x) / 100, py = (c.y == null ? 50 : c.y) / 100, z = c.z || 1;
    var s = Math.max(w / img.naturalWidth, h / img.naturalHeight), dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    var ox = (w - dw) * px, oy = (h - dh) * py, ax = px * w, ay = py * h;
    ox = ax + (ox - ax) * z; oy = ay + (oy - ay) * z;
    ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.drawImage(img, x + ox, y + oy, dw * z, dh * z);
    ctx.restore();
  }
  function gray(ctx, x, y, w, h) {
    var x0 = Math.max(0, Math.floor(x)), y0 = Math.max(0, Math.floor(y));
    w = Math.ceil(x + w) - x0; h = Math.ceil(y + h) - y0; x = x0; y = y0;
    if (w < 1 || h < 1) return;
    try {
      var d = ctx.getImageData(x, y, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) { var g = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]; p[i] = p[i + 1] = p[i + 2] = g; }
      ctx.putImageData(d, x, y);
    } catch (e) {}
  }
  function hatch(ctx, x, y, w, h, a, b) {
    ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.fillStyle = a || '#efeae1'; ctx.fillRect(x, y, w, h);
    ctx.strokeStyle = b || '#e3dccf'; ctx.lineWidth = 6;
    for (var k = -h; k < w; k += 16) { ctx.beginPath(); ctx.moveTo(x + k, y + h); ctx.lineTo(x + k + h, y); ctx.stroke(); }
    ctx.restore();
  }
  function badge(ctx, text, x, y, size) {
    size = size || 13;
    ctx.save();
    ctx.font = '700 ' + size + 'px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
    var w = ctx.measureText(text).width + size * 0.9, hh = size * 1.55;
    ctx.fillStyle = 'rgba(22, 34, 74, .85)';
    roundRect(ctx, x, y, w, hh, hh / 2); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.textBaseline = 'middle'; ctx.fillText(text, x + size * 0.45, y + hh / 2 + 0.5);
    ctx.restore();
  }
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h); ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r); ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.closePath();
  }
  /* texto con salto de línea dentro de un ancho; devuelve la altura usada */
  function wrap(ctx, text, x, y, maxW, lh, maxLines) {
    var words = String(text || '').split(/\s+/), line = '', lines = [];
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    if (maxLines && lines.length > maxLines) { lines = lines.slice(0, maxLines); lines[maxLines - 1] += '…'; }
    lines.forEach(function (l, i) { ctx.fillText(l, x, y + i * lh); });
    return lines.length * lh;
  }
  function canvas(w, h) {
    var c = document.createElement('canvas'); c.width = Math.round(w); c.height = Math.round(h);
    try { c.getContext('2d', { willReadFrequently: true }); } catch (e) {}
    return c;
  }
  function stamp() {
    var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
    return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
  }

  function toBlob(c, q) {
    return new Promise(function (resolve) {
      try {
        if (c.toBlob) return c.toBlob(function (b) { resolve(b); }, 'image/jpeg', q || 0.86);
        var u = c.toDataURL('image/jpeg', q || 0.86), bin = atob(u.split(',')[1]), arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        resolve(new Blob([arr], { type: 'image/jpeg' }));
      } catch (e) { resolve(null); }   // canvas bloqueado o sin memoria
    });
  }
  /* subida directa a Uploadcare con la llave pública que ya usa Uploadly; STORE=1 para que no se borre a las 24 h */
  function upload(c, name, q) {
    var key = window.UPLOADCARE_PUBLIC_KEY || (window.uploadcare && window.uploadcare.defaults && window.uploadcare.defaults.publicKey);
    if (!key || !window.fetch || !window.FormData) return Promise.resolve(null);
    return toBlob(c, q).then(function (blob) {
      if (!blob) return null;
      var fd = new FormData();
      fd.append('UPLOADCARE_PUB_KEY', key);
      fd.append('UPLOADCARE_STORE', '1');
      fd.append('file', blob, name || 'vista-previa.jpg');
      var urlBase = (window.uploadcare && window.uploadcare.defaults && window.uploadcare.defaults.urlBase) || 'https://upload.uploadcare.com';
      var cdn = (window.uploadcare && window.uploadcare.defaults && window.uploadcare.defaults.cdnBase) || 'https://ucarecdn.com';
      var timer, timeout = new Promise(function (r) { timer = setTimeout(function () { r(null); }, UPLOAD_TIMEOUT); });
      var req = fetch(urlBase.replace(/\/$/, '') + '/base/', { method: 'POST', body: fd })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.file ? cdn.replace(/\/$/, '') + '/' + j.file + '/' + encodeURIComponent(name || 'vista-previa.jpg') : null; })
        .catch(function () { return null; });
      return Promise.race([req, timeout]).then(function (u) { clearTimeout(timer); return u; });
    }).catch(function () { return null; });
  }

  /* aviso con dos botones (reemplaza a window.confirm): ask({ title, text, ok, cancel }) → Promise<boolean> */
  function ask(o) {
    o = o || {};
    return new Promise(function (resolve) {
      var prev = document.activeElement, box = document.createElement('div');
      box.className = 'wpns'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      box.innerHTML = '<div class="wpns__card">' + (o.icon ? '<div class="wpns__icon" aria-hidden="true">' + o.icon + '</div>' : '') +
        '<h3 class="wpns__t">' + esc(o.title || '¿Continuar?') + '</h3>' +
        (o.text ? '<p class="wpns__p">' + esc(o.text) + '</p>' : '') + (o.note ? '<p class="wpns__note">' + esc(o.note) + '</p>' : '') +
        '<div class="wpns__actions"><button type="button" class="wpns__no">' + esc(o.cancel || 'Volver') + '</button><button type="button" class="wpns__ok">' + esc(o.ok || 'Continuar') + '</button></div></div>';
      var done = false;
      function close(v) {
        if (done) return; done = true;
        document.removeEventListener('keydown', onKey, true);
        box.classList.remove('is-on'); setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 180);
        try { if (prev && prev.focus) prev.focus({ preventScroll: true }); } catch (e) {}
        resolve(v);
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(false); }
        else if (e.key === 'Tab') { var a = box.querySelector('.wpns__no'), b = box.querySelector('.wpns__ok'); if (document.activeElement === b && !e.shiftKey) { e.preventDefault(); a.focus(); } else if (document.activeElement === a && e.shiftKey) { e.preventDefault(); b.focus(); } }
      }
      box.addEventListener('click', function (e) { if (e.target === box) close(false); });
      box.querySelector('.wpns__no').addEventListener('click', function (e) { e.stopPropagation(); close(false); });
      box.querySelector('.wpns__ok').addEventListener('click', function (e) { e.stopPropagation(); close(true); });
      document.addEventListener('keydown', onKey, true);
      document.body.appendChild(box);
      requestAnimationFrame(function () { box.classList.add('is-on'); try { box.querySelector('.wpns__ok').focus({ preventScroll: true }); } catch (e) {} });
    });
  }
  /* texto común del aviso "Continuar sin fotos" */
  var NO_PHOTOS = {
    title: 'Continuar sin fotos',
    text: 'Agregamos tu pedido al carrito para que pagues ahora. Después de tu compra te escribimos por WhatsApp para que nos envíes tus fotos y armamos tu diseño contigo.',
    note: 'Si prefieres, también puedes subirlas ahora y ver cómo queda antes de pagar.',
    ok: 'Sí, continuar', cancel: 'Subir mis fotos',
    icon: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 20.5l1.6-5.4A8.4 8.4 0 1 1 21 11.5z"/><path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01"/></svg>',
    prop: 'Sin fotos: el cliente las enviará por WhatsApp después de la compra'
  };

  window.WPCapture = { ask: ask, NO_PHOTOS: NO_PHOTOS, load: load, loadAll: loadAll, cover: cover, gray: gray, hatch: hatch, badge: badge, roundRect: roundRect, wrap: wrap, canvas: canvas, stamp: stamp, upload: upload, toBlob: toBlob };
})();
